module.exports = __webpack_public_path__ + "img/MarketIcon.9a34e254.svg";